import React from 'react';
import { BetaTag } from './styled';
import { isBetaDimension } from './utils';

type DimensionBetaLabelProps = {
  name: string;
  groupBy?: string;
};

const DimensionBetaLabel = ({ name, groupBy }: DimensionBetaLabelProps) => (
  <span>
    {name}
    {isBetaDimension({ key: groupBy, name }) ? <BetaTag>Beta</BetaTag> : null}
  </span>
);

export default DimensionBetaLabel;
